export const TOKEN_COOKIE_KEY = "nani_oneclass_login_token";

export const ONECLASS_DOMAIN = "oneclass.com.tw";
export const NANI_DOMAIN = "nani.com.tw";

export const DOMAINS = [ONECLASS_DOMAIN, NANI_DOMAIN] as const;

export const NANI_CLUB_OIDC_AUTH_PATH = "/oidc/auth";
